{
  "username": "Kullanıcı Adı",
  "password": "Şifre",
  "login": "Giriş Yap",
  "confirm": "Onayla",
  "cancel": "İptal",
  "close": "Kapat",
  "save": "Kaydet",
  "logout": "Çıkış Yap",
  "create": "Oluştur",
  "add": "Ekle",
  "remove": "Kaldır",
  "update": "Güncelle",
  "copy": "Kopyala",
  "copied": "Kopyalandı",
  "more": "daha",
  "download": "İndir",
  "remark": "Açıklama",
  "enable": "Etkin",
  "protocol": "Protokol",
  "search": "Ara",
  "filter": "Filtre",
  "all": "Tümü",
  "from": "Başlangıç",
  "to": "Bitiş",
  "done": "Tamam",
  "loading": "Yükleniyor...",
  "refresh": "Yenile",
  "clear": "Temizle",
  "second": "Saniye",
  "minute": "Dakika",
  "hour": "Saat",
  "day": "Gün",
  "check": "Kontrol Et",
  "indefinite": "Belirsiz",
  "unlimited": "Sınırsız",
  "none": "Yok",
  "qrCode": "QR Kod",
  "info": "Daha Fazla Bilgi",
  "edit": "Düzenle",
  "delete": "Sil",
  "reset": "Sıfırla",
  "noData": "Veri yok.",
  "copySuccess": "Başarıyla Kopyalandı",
  "sure": "Emin misiniz",
  "encryption": "Şifreleme",
  "useIPv4ForHost": "Ana bilgisayar için IPv4 kullan",
  "transmission": "İletim",
  "host": "Host",
  "path": "Yol",
  "camouflage": "Karartma",
  "status": "Durum",
  "enabled": "Etkin",
  "disabled": "Devre Dışı",
  "depleted": "Bitti",
  "depletingSoon": "Bitmek Üzere",
  "offline": "Çevrimdışı",
  "online": "Çevrimiçi",
  "domainName": "Alan Adı",
  "monitor": "Dinleme IP",
  "certificate": "Dijital Sertifika",
  "fail": "Başarısız",
  "comment": "Yorum",
  "success": "Başarılı",
  "lastOnline": "Son çevrimiçi",
  "getVersion": "Sürümü Al",
  "install": "Yükle",
  "clients": "Müşteriler",
  "usage": "Kullanım",
  "twoFactorCode": "Kod",
  "remained": "Kalan",
  "security": "Güvenlik",
  "secAlertTitle": "Güvenlik Uyarısı",
  "secAlertSsl": "Bu bağlantı güvenli değil. Verilerin korunması için TLS etkinleştirilene kadar hassas bilgiler girmekten kaçının.",
  "secAlertConf": "Bazı ayarlar saldırılara açıktır. Olası ihlalleri önlemek için güvenlik protokollerini güçlendirmeniz önerilir.",
  "secAlertSSL": "Panelde güvenli bağlantı yok. Verilerin korunması için TLS sertifikası yükleyin.",
  "secAlertPanelPort": "Panel varsayılan portu savunmasız. Rastgele veya belirli bir port yapılandırın.",
  "secAlertPanelURI": "Panel varsayılan URI yolu güvensiz. Karmaşık bir URI yolu yapılandırın.",
  "secAlertSubURI": "Abonelik varsayılan URI yolu güvensiz. Karmaşık bir URI yolu yapılandırın.",
  "secAlertSubJsonURI": "Abonelik JSON varsayılan URI yolu güvensiz. Karmaşık bir URI yolu yapılandırın.",
  "emptyDnsDesc": "Eklenmiş DNS sunucusu yok.",
  "emptyFakeDnsDesc": "Eklenmiş Fake DNS sunucusu yok.",
  "emptyBalancersDesc": "Eklenmiş dengeleyici yok.",
  "emptyReverseDesc": "Eklenmiş ters proxy yok.",
  "somethingWentWrong": "Bir şeyler yanlış gitti",
  "subscription": {
    "title": "Abonelik Bilgisi",
    "subId": "Abonelik Kimliği",
    "status": "Durum",
    "downloaded": "İndirilen",
    "uploaded": "Yüklenen",
    "expiry": "Son Kullanma",
    "totalQuota": "Toplam Kota",
    "individualLinks": "Bireysel Bağlantılar",
    "active": "Aktif",
    "inactive": "Pasif",
    "unlimited": "Sınırsız",
    "noExpiry": "Süresiz"
  },
  "menu": {
    "theme": "Tema",
    "dark": "Koyu",
    "ultraDark": "Ultra Koyu",
    "dashboard": "Genel Bakış",
    "inbounds": "Gelenler",
    "clients": "İstemciler",
    "groups": "Gruplar",
    "nodes": "Düğümler",
    "settings": "Panel Ayarları",
    "xray": "Xray Yapılandırmaları",
    "apiDocs": "API Belgeleri",
    "logout": "Çıkış Yap",
    "link": "Yönet",
    "donate": "Bağış Yap"
  },
  "pages": {
    "login": {
      "hello": "Merhaba",
      "title": "Hoş Geldiniz",
      "loginAgain": "Oturum süreniz doldu, lütfen tekrar giriş yapın",
      "toasts": {
        "invalidFormData": "Girdi verisi formatı geçersiz.",
        "emptyUsername": "Kullanıcı adı gerekli",
        "emptyPassword": "Şifre gerekli",
        "wrongUsernameOrPassword": "Geçersiz kullanıcı adı, şifre veya iki adımlı doğrulama kodu.",
        "successLogin": "Hesabınıza başarıyla giriş yaptınız."
      }
    },
    "index": {
      "title": "Genel Bakış",
      "cpu": "CPU",
      "logicalProcessors": "Mantıksal işlemciler",
      "frequency": "Frekans",
      "swap": "Swap",
      "storage": "Depolama",
      "memory": "RAM",
      "threads": "İş parçacığı",
      "xrayStatus": "Xray",
      "stopXray": "Durdur",
      "restartXray": "Yeniden başlat",
      "xraySwitch": "Sürüm",
      "xrayUpdates": "Xray Güncellemeleri",
      "xraySwitchClick": "Geçiş yapmak istediğiniz sürümü seçin.",
      "xraySwitchClickDesk": "Dikkatli seçin, eski sürümler mevcut yapılandırmalarla uyumlu olmayabilir.",
      "updatePanel": "Paneli Güncelle",
      "panelUpdateDesc": "Bu, 3X-UI'yi en son sürüme güncelleyecek ve panel servisini yeniden başlatacaktır.",
      "currentPanelVersion": "Mevcut panel sürümü",
      "latestPanelVersion": "Panelin en son sürümü",
      "panelUpToDate": "Panel güncel",
      "upToDate": "Güncel",
      "xrayStatusUnknown": "Bilinmiyor",
      "xrayStatusRunning": "Çalışıyor",
      "xrayStatusStop": "Durduruldu",
      "xrayStatusError": "Hata",
      "xrayErrorPopoverTitle": "Xray çalıştırılırken bir hata oluştu",
      "operationHours": "Çalışma Süresi",
      "systemHistoryTitle": "Sistem Geçmişi",
      "charts": "Grafikler",
      "xrayMetricsTitle": "Xray Metrikleri",
      "xrayMetricsDisabled": "Xray metrik uç noktası yapılandırılmadı",
      "xrayMetricsHint": "xray yapılandırmasına tag metrics_out ve listen 127.0.0.1:11111 olan üst düzey bir metrics bloğu ekleyin, sonra xray'i yeniden başlatın.",
      "xrayObservatoryEmpty": "Henüz Observatory verisi yok",
      "xrayObservatoryHint": "xray yapılandırmasına test edilecek outbound etiketlerini listeleyen bir observatory bloğu ekleyin, sonra xray'i yeniden başlatın.",
      "xrayObservatoryTagPlaceholder": "Outbound seç",
      "xrayObservatoryAlive": "Aktif",
      "xrayObservatoryDead": "Kapalı",
      "xrayObservatoryLastSeen": "Son görülme",
      "xrayObservatoryLastTry": "Son deneme",
      "trendLast2Min": "Son 2 dakika",
      "systemLoad": "Sistem Yükü",
      "systemLoadDesc": "Geçmiş 1, 5 ve 15 dakika için sistem yük ortalaması",
      "connectionCount": "Bağlantı İstatistikleri",
      "ipAddresses": "IP adresleri",
      "toggleIpVisibility": "IP görünürlüğünü değiştir",
      "overallSpeed": "Genel hız",
      "upload": "Yükleme",
      "download": "İndir",
      "totalData": "Toplam veri",
      "sent": "Gönderilen",
      "received": "Alınan",
      "documentation": "Dokümantasyon",
      "xraySwitchVersionDialog": "Xray sürümünü gerçekten değiştirmek istiyor musunuz?",
      "xraySwitchVersionDialogDesc": "Bu işlem Xray sürümünü #version# olarak değiştirecektir.",
      "xraySwitchVersionPopover": "Xray başarıyla güncellendi",
      "panelUpdateDialog": "Gerçekten paneli güncellemek istiyor musunuz?",
      "panelUpdateDialogDesc": "Bu, 3X-UI'yi #version# sürümüne güncelleyecek ve panel servisini yeniden başlatacaktır.",
      "panelUpdateCheckPopover": "Panel güncelleme kontrolü başarısız oldu",
      "panelUpdateStartedPopover": "Panel güncellemesi başlatıldı",
      "geofileUpdateDialog": "Geofile'ı gerçekten güncellemek istiyor musunuz?",
      "geofileUpdateDialogDesc": "Bu işlem #filename# dosyasını güncelleyecektir.",
      "geofilesUpdateDialogDesc": "Bu, tüm dosyaları güncelleyecektir.",
      "geofilesUpdateAll": "Tümünü güncelle",
      "geofileUpdatePopover": "Geofile başarıyla güncellendi",
      "customGeoTitle": "Özel GeoSite / GeoIP",
      "customGeoAdd": "Ekle",
      "customGeoType": "Tür",
      "customGeoAlias": "Takma ad",
      "customGeoUrl": "URL",
      "customGeoEnabled": "Etkin",
      "customGeoLastUpdated": "Son güncelleme",
      "customGeoExtColumn": "Yönlendirme (ext:…)",
      "customGeoToastUpdateAll": "Tüm özel kaynaklar güncellendi",
      "customGeoActions": "İşlemler",
      "customGeoEdit": "Düzenle",
      "customGeoDelete": "Sil",
      "customGeoDownload": "Şimdi güncelle",
      "customGeoModalAdd": "Özel geo ekle",
      "customGeoModalEdit": "Özel geo düzenle",
      "customGeoModalSave": "Kaydet",
      "customGeoDeleteConfirm": "Bu özel geo kaynağını silinsin mi?",
      "customGeoRoutingHint": "Yönlendirme kurallarında değer sütununu ext:dosya.dat:etiket olarak kullanın (etiketi değiştirin).",
      "customGeoInvalidId": "Geçersiz kaynak kimliği",
      "customGeoAliasesError": "Özel geo takma adları yüklenemedi",
      "customGeoValidationAlias": "Takma ad yalnızca küçük harf, rakam, - ve _ içerebilir",
      "customGeoValidationUrl": "URL http:// veya https:// ile başlamalıdır",
      "customGeoAliasPlaceholder": "a-z 0-9 _ -",
      "customGeoAliasLabelSuffix": " (özel)",
      "customGeoToastList": "Özel geo listesi",
      "customGeoToastAdd": "Özel geo ekle",
      "customGeoToastUpdate": "Özel geo güncelle",
      "customGeoToastDelete": "Özel geofile \"{{ .fileName }}\" silindi",
      "customGeoToastDownload": "\"{{ .fileName }}\" geofile güncellendi",
      "customGeoErrInvalidType": "Tür geosite veya geoip olmalıdır",
      "customGeoErrAliasRequired": "Takma ad gerekli",
      "customGeoErrAliasPattern": "Takma ad izin verilmeyen karakterler içeriyor",
      "customGeoErrAliasReserved": "Bu takma ad ayrılmış",
      "customGeoErrUrlRequired": "URL gerekli",
      "customGeoErrInvalidUrl": "URL geçersiz",
      "customGeoErrUrlScheme": "URL http veya https kullanmalıdır",
      "customGeoErrUrlHost": "URL ana bilgisayarı geçersiz",
      "customGeoErrDuplicateAlias": "Bu takma ad bu tür için zaten kullanılıyor",
      "customGeoErrNotFound": "Özel geo kaynağı bulunamadı",
      "customGeoErrDownload": "İndirme başarısız",
      "customGeoErrUpdateAllIncomplete": "Bir veya daha fazla özel geo kaynağı güncellenemedi",
      "customGeoEmpty": "Henüz özel geo kaynağı yok — oluşturmak için Ekle'ye tıklayın",
      "dontRefresh": "Kurulum devam ediyor, lütfen bu sayfayı yenilemeyin",
      "logs": "Günlükler",
      "config": "Yapılandırma",
      "backup": "Yedek",
      "backupTitle": "Yedekleme & Geri Yükleme",
      "exportDatabase": "Yedekle",
      "exportDatabaseDesc": "Mevcut veritabanınızın yedeğini içeren bir .db dosyasını cihazınıza indirmek için tıklayın.",
      "importDatabase": "Geri Yükle",
      "importDatabaseDesc": "Cihazınızdan bir .db dosyası seçip yükleyerek veritabanınızı yedekten geri yüklemek için tıklayın.",
      "importDatabaseSuccess": "Veritabanı başarıyla içe aktarıldı",
      "importDatabaseError": "Veritabanı içe aktarılırken bir hata oluştu",
      "readDatabaseError": "Veritabanı okunurken bir hata oluştu",
      "getDatabaseError": "Veritabanı alınırken bir hata oluştu",
      "getConfigError": "Yapılandırma dosyası alınırken bir hata oluştu"
    },
    "inbounds": {
      "title": "Gelenler",
      "totalDownUp": "Toplam Gönderilen/Alınan",
      "totalUsage": "Toplam Kullanım",
      "inboundCount": "Toplam Gelen",
      "operate": "Menü",
      "enable": "Etkin",
      "remark": "Açıklama",
      "node": "Düğüm",
      "deployTo": "Şuraya dağıt",
      "localPanel": "Yerel panel",
      "fallbacks": {
        "title": "Fallback'ler",
        "help": "Bu inbound üzerindeki bir bağlantı hiçbir client ile eşleşmediğinde, başka bir inbound'a yönlendirilir. Aşağıdan bir child seçin; yönlendirme alanları (SNI / ALPN / Path / xver) onun transport'undan otomatik dolar — çoğu kurulum için ek ayar gerekmez. Her child 127.0.0.1 üzerinde security=none ile dinlemelidir.",
        "empty": "Henüz fallback yok",
        "add": "Fallback ekle",
        "pickInbound": "Bir inbound seç",
        "matchAny": "herhangi",
        "destPlaceholder": "otomatik (child listen:port)",
        "rederive": "Child'dan yeniden doldur",
        "rederived": "Child'dan yeniden dolduruldu",
        "editAdvanced": "Yönlendirme alanlarını düzenle",
        "hideAdvanced": "Gelişmişi gizle",
        "quickAddAll": "Uygun olan tümünü hızlı ekle",
        "quickAdded": "{n} fallback eklendi",
        "quickAddedNone": "Eklenecek yeni uygun inbound yok",
        "routesWhen": "Şu durumda yönlendirir",
        "defaultCatchAll": "Varsayılan — başka her şeyi yakalar"
      },
      "protocol": "Protokol",
      "port": "Port",
      "portMap": "Port eşlemesi",
      "traffic": "Trafik",
      "details": "Detaylar",
      "transportConfig": "Taşıma",
      "expireDate": "Süre",
      "createdAt": "Oluşturuldu",
      "updatedAt": "Güncellendi",
      "resetTraffic": "Trafiği sıfırla",
      "addInbound": "Gelen Ekle",
      "generalActions": "Genel Eylemler",
      "modifyInbound": "Geleni Düzenle",
      "deleteInbound": "Geleni Sil",
      "deleteInboundContent": "Geleni silmek istediğinizden emin misiniz?",
      "deleteConfirmTitle": "\"{remark}\" inbound silinsin mi?",
      "deleteConfirmContent": "Bu işlem inbound'u ve tüm istemcilerini siler. Geri alınamaz.",
      "resetConfirmTitle": "\"{remark}\" trafiği sıfırlansın mı?",
      "resetConfirmContent": "Bu inbound için gönderme/alma sayaçlarını 0'a sıfırlar.",
      "cloneConfirmTitle": "\"{remark}\" inbound klonlansın mı?",
      "cloneConfirmContent": "Yeni bir port ve boş istemci listesiyle bir kopya oluşturur.",
      "delAllClients": "Tüm istemcileri sil",
      "delAllClientsConfirmTitle": "\"{remark}\" içindeki {count} istemcinin tamamı silinsin mi?",
      "delAllClientsConfirmContent": "Bu inbound'a ait tüm istemcileri ve trafik kayıtlarını siler. Inbound'un kendisi korunur. Bu işlem geri alınamaz.",
      "attachClients": "İstemcileri şuna bağla…",
      "addClientsToGroup": "İstemcileri gruba ekle…",
      "attachClientsTitle": "«{remark}» gelenindeki istemcileri bağla",
      "attachClientsDesc": "Aynı {count} istemciyi (aynı UUID/parola ve paylaşılan trafik) seçilen gelenlere bağlar. Bu gelende de kalırlar.",
      "attachClientsTargets": "Hedef gelenler",
      "attachClientsNoTargets": "Bağlanacak uyumlu başka gelen yok.",
      "attachClientsResult": "Bağlandı {attached}, atlandı {skipped}.",
      "attachClientsResultMixed": "Bağlandı {attached}, atlandı {skipped}, hata {errors}.",
      "attachClientsSelectLabel": "Bağlanacak istemciler",
      "attachClientsSearchPlaceholder": "Email veya yorum ara",
      "attachClientsStatusDisabled": "Devre dışı",
      "attachClientsSelectedCount": "{total} içinden {selected} seçildi",
      "detachClients": "İstemcileri çöz",
      "detachClientsTitle": "«{remark}» gelenindeki istemcileri çöz",
      "detachClientsDesc": "Seçilen istemcileri yalnızca bu gelenden kaldırır. İstemci kayıtları korunur (tamamen kaldırmak için Delete kullanın). Kaynakta toplam {count} istemci var.",
      "detachClientsResult": "Çözüldü {detached}, atlandı {skipped}.",
      "detachClientsResultMixed": "Çözüldü {detached}, atlandı {skipped}, hata {errors}.",
      "detachClientsSelectLabel": "Çözülecek istemciler",
      "exportLinksTitle": "Inbound bağlantılarını dışa aktar",
      "exportSubsTitle": "Abonelik bağlantılarını dışa aktar",
      "exportAllLinksTitle": "Tüm inbound bağlantılarını dışa aktar",
      "exportAllSubsTitle": "Tüm abonelik bağlantılarını dışa aktar",
      "exportAllLinksFileName": "Tum-Gelenler",
      "exportAllSubsFileName": "Tum-Gelenler-Subs",
      "inboundJsonTitle": "Gelen JSON",
      "deleteClient": "Müşteriyi Sil",
      "deleteClientContent": "Müşteriyi silmek istediğinizden emin misiniz?",
      "resetTrafficContent": "Trafiği sıfırlamak istediğinizden emin misiniz?",
      "copyLink": "URL'yi Kopyala",
      "address": "Adres",
      "network": "Ağ",
      "destinationPort": "Hedef Port",
      "targetAddress": "Hedef Adres",
      "monitorDesc": "Tüm IP'leri dinlemek için boş bırakın",
      "meansNoLimit": "= Sınırsız. (birim: GB)",
      "totalFlow": "Toplam Akış",
      "leaveBlankToNeverExpire": "Hiçbir zaman sona ermemesi için boş bırakın",
      "noRecommendKeepDefault": "Varsayılanı korumanız önerilir",
      "certificatePath": "Dosya Yolu",
      "certificateContent": "Dosya İçeriği",
      "publicKey": "Genel Anahtar",
      "privatekey": "Özel Anahtar",
      "clickOnQRcode": "Kopyalamak için QR Kodu Tıklayın",
      "client": "Müşteri",
      "export": "Tüm URL'leri Dışa Aktar",
      "clone": "Klonla",
      "cloneInbound": "Klonla",
      "cloneInboundContent": "Bu gelenin tüm ayarları, Port, Dinleme IP ve Müşteriler hariç, klona uygulanacaktır.",
      "cloneInboundOk": "Klonla",
      "resetAllTraffic": "Tüm Gelen Trafiğini Sıfırla",
      "resetAllTrafficTitle": "Tüm Gelen Trafiğini Sıfırla",
      "resetAllTrafficContent": "Tüm gelenlerin trafiğini sıfırlamak istediğinizden emin misiniz?",
      "resetInboundClientTraffics": "Müşteri Trafiklerini Sıfırla",
      "resetInboundClientTrafficTitle": "Müşteri Trafiklerini Sıfırla",
      "resetInboundClientTrafficContent": "Bu gelenin müşterilerinin trafiğini sıfırlamak istediğinizden emin misiniz?",
      "resetAllClientTraffics": "Tüm Müşteri Trafiklerini Sıfırla",
      "resetAllClientTrafficTitle": "Tüm Müşteri Trafiklerini Sıfırla",
      "resetAllClientTrafficContent": "Tüm müşterilerin trafiğini sıfırlamak istediğinizden emin misiniz?",
      "delDepletedClients": "Bitmiş Müşterileri Sil",
      "delDepletedClientsTitle": "Bitmiş Müşterileri Sil",
      "delDepletedClientsContent": "Tüm bitmiş müşterileri silmek istediğinizden emin misiniz?",
      "email": "Email",
      "emailDesc": "Lütfen benzersiz bir e-posta adresi sağlayın.",
      "IPLimit": "IP Limiti",
      "IPLimitDesc": "Sayının aşılması durumunda gelen devre dışı bırakılır. (0 = devre dışı)",
      "IPLimitlog": "IP Günlüğü",
      "IPLimitlogDesc": "IP geçmiş günlüğü. (devre dışı bırakıldıktan sonra gelini etkinleştirmek için günlüğü temizleyin)",
      "IPLimitlogclear": "Günlüğü Temizle",
      "setDefaultCert": "Panelden Sertifikayı Ayarla",
      "setDefaultCertEmpty": "Panel için sertifika yapılandırılmamış. Önce Ayarlar'dan ayarlayın.",
      "streamTab": "Akış",
      "securityTab": "Güvenlik",
      "sniffingTab": "Dinleme",
      "sniffingMetadataOnly": "Yalnızca üst veri",
      "sniffingRouteOnly": "Yalnızca yönlendirme",
      "sniffingIpsExcluded": "Hariç tutulan IP'ler",
      "sniffingDomainsExcluded": "Hariç tutulan alan adları",
      "decryption": "Şifre çözme",
      "encryption": "Şifreleme",
      "vlessAuthX25519": "X25519 kimlik doğrulama",
      "vlessAuthMlkem768": "ML-KEM-768 kimlik doğrulama",
      "vlessAuthCustom": "Özel",
      "vlessAuthSelected": "Seçili: {auth}",
      "advanced": {
        "title": "Inbound JSON bölümleri",
        "subtitle": "Tam inbound JSON'u ve settings, sniffing, streamSettings için odaklanmış düzenleyiciler.",
        "all": "Tümü",
        "allHelp": "Tüm alanları tek bir düzenleyicide içeren tam inbound nesnesi.",
        "settings": "Ayarlar",
        "settingsHelp": "Xray settings bloğunun sarmalayıcısı:",
        "sniffing": "Sniffing",
        "sniffingHelp": "Xray sniffing bloğunun sarmalayıcısı:",
        "stream": "Stream",
        "streamHelp": "Xray stream bloğunun sarmalayıcısı:",
        "jsonErrorPrefix": "Gelişmiş JSON"
      },
      "telegramDesc": "Lütfen Telegram Sohbet Kimliği sağlayın. (botta '/id' komutunu kullanın) veya ({'@'}userinfobot)",
      "subscriptionDesc": "Abonelik URL'inizi bulmak için 'Detaylar'a gidin. Ayrıca, aynı adı birden fazla müşteri için kullanabilirsiniz.",
      "same": "Aynı",
      "inboundData": "Gelenin Verileri",
      "exportInbound": "Geleni Dışa Aktar",
      "import": "İçe Aktar",
      "importInbound": "Bir Gelen İçe Aktar",
      "periodicTrafficResetTitle": "Trafik Sıfırlama",
      "periodicTrafficResetDesc": "Belirtilen aralıklarla trafik sayacını otomatik olarak sıfırla",
      "lastReset": "Son Sıfırlama",
      "periodicTrafficReset": {
        "never": "Asla",
        "daily": "Günlük",
        "weekly": "Haftalık",
        "monthly": "Aylık",
        "hourly": "Saatlik"
      },
      "toasts": {
        "obtain": "Elde Et",
        "updateSuccess": "Güncelleme başarılı oldu",
        "logCleanSuccess": "Günlük temizlendi",
        "inboundsUpdateSuccess": "Gelen bağlantılar başarıyla güncellendi",
        "inboundUpdateSuccess": "Gelen bağlantı başarıyla güncellendi",
        "inboundCreateSuccess": "Gelen bağlantı başarıyla oluşturuldu",
        "inboundDeleteSuccess": "Gelen bağlantı başarıyla silindi",
        "inboundClientAddSuccess": "Gelen bağlantı istemci(leri) eklendi",
        "inboundClientDeleteSuccess": "Gelen bağlantı istemcisi silindi",
        "inboundClientUpdateSuccess": "Gelen bağlantı istemcisi güncellendi",
        "delDepletedClientsSuccess": "Tüm tükenmiş istemciler silindi",
        "resetAllClientTrafficSuccess": "İstemcinin tüm trafiği sıfırlandı",
        "resetAllTrafficSuccess": "Tüm trafik sıfırlandı",
        "resetInboundClientTrafficSuccess": "Trafik sıfırlandı",
        "resetInboundTrafficSuccess": "Gelen trafik sıfırlandı",
        "trafficGetError": "Trafik bilgisi alınırken hata oluştu",
        "getNewX25519CertError": "X25519 sertifikası alınırken hata oluştu.",
        "getNewmldsa65Error": "mldsa65 sertifikası alınırken hata oluştu.",
        "getNewVlessEncError": "VlessEnc sertifikası alınırken hata oluştu."
      },
      "form": {
        "moveUp": "Yukarı",
        "moveDown": "Aşağı",
        "addAll": "Tümünü ekle",
        "addAllFallbackTooltip": "Henüz bağlanmamış her uygun gelen için bir fallback satırı ekler",
        "peers": "Peers",
        "addPeer": "Peer ekle",
        "keepAlive": "Keep-alive",
        "autoSystemRoutesTooltip": "Yalnızca Windows. CIDR'ler eşleşen trafiğin TUN üzerinden gitmesi için sistem yönlendirme tablosuna otomatik eklenir.",
        "autoOutboundsInterface": "Otomatik giden arabirimi",
        "autoOutboundsInterfaceTooltip": "Giden trafiği için fiziksel arabirim. Tespit için 'auto' kullanın; Auto system routes açıkken otomatik etkinleşir.",
        "rewriteAddress": "Adresi yeniden yaz",
        "rewritePort": "Port'u yeniden yaz",
        "allowedNetwork": "İzin verilen ağ",
        "followRedirect": "Redirect'i takip et",
        "accounts": "Hesaplar",
        "allowTransparent": "Şeffafa izin ver",
        "encryptionMethod": "Şifreleme yöntemi",
        "visionTestseed": "Vision testseed",
        "version": "Sürüm",
        "udpIdleTimeout": "UDP idle timeout (s)",
        "masquerade": "Masquerade",
        "type": "Tip",
        "upstreamUrl": "Upstream URL",
        "rewriteHost": "Host'u yeniden yaz",
        "skipTlsVerify": "TLS doğrulamayı atla",
        "directory": "Dizin",
        "statusCode": "Durum kodu",
        "body": "Body",
        "headers": "Başlıklar",
        "proxyProtocol": "Proxy Protocol",
        "requestVersion": "İstek sürümü",
        "requestMethod": "İstek yöntemi",
        "requestPath": "İstek yolu",
        "requestHeaders": "İstek başlıkları",
        "responseVersion": "Yanıt sürümü",
        "responseStatus": "Yanıt durumu",
        "responseReason": "Yanıt sebebi",
        "responseHeaders": "Yanıt başlıkları",
        "heartbeatPeriod": "Heartbeat periyodu",
        "serviceName": "Servis adı",
        "authority": "Authority",
        "multiMode": "Multi Mode",
        "maxBufferedUpload": "Maks. tamponlu yükleme",
        "maxUploadSize": "Maks. yükleme boyutu (Byte)",
        "streamUpServer": "Stream-Up Server",
        "serverMaxHeaderBytes": "Sunucu maks. başlık bayt",
        "paddingBytes": "Padding bayt",
        "uplinkHttpMethod": "Uplink HTTP yöntemi",
        "paddingObfsMode": "Padding obfs modu",
        "paddingKey": "Padding Key",
        "paddingHeader": "Padding Header",
        "paddingPlacement": "Padding konumu",
        "paddingMethod": "Padding yöntemi",
        "sessionPlacement": "Session Placement",
        "sessionKey": "Session Key",
        "sequencePlacement": "Sequence Placement",
        "sequenceKey": "Sequence Key",
        "uplinkDataPlacement": "Uplink Data Placement",
        "uplinkDataKey": "Uplink Data Key",
        "noSseHeader": "SSE başlığı yok",
        "ttiMs": "TTI (ms)",
        "uplinkMbps": "Yükleme (MB/s)",
        "downlinkMbps": "İndirme (MB/s)",
        "cwndMultiplier": "CWND çarpanı",
        "maxSendingWindow": "Maks. gönderme penceresi",
        "externalProxy": "Harici proxy",
        "sniPlaceholder": "SNI (varsayılan host)",
        "fingerprint": "Fingerprint",
        "defaultOption": "Varsayılan",
        "routeMark": "Route Mark",
        "tcpKeepAliveInterval": "TCP Keep Alive Interval",
        "tcpKeepAliveIdle": "TCP Keep Alive Idle",
        "tcpMaxSeg": "TCP Max Seg",
        "tcpUserTimeout": "TCP User Timeout",
        "tcpWindowClamp": "TCP Window Clamp",
        "tcpFastOpen": "TCP Fast Open",
        "multipathTcp": "Multipath TCP",
        "penetrate": "Penetrate",
        "v6Only": "Yalnızca V6",
        "tcpCongestion": "TCP Congestion",
        "dialerProxy": "Dialer Proxy",
        "trustedXForwardedFor": "Güvenilir X-Forwarded-For",
        "addressPortStrategy": "Adres+port stratejisi",
        "tryDelayMs": "Deneme gecikmesi (ms)",
        "prioritizeIPv6": "IPv6 önceliği",
        "interleave": "Interleave",
        "maxConcurrentTry": "Maks. eş zamanlı deneme",
        "customSockopt": "Özel sockopt",
        "addCustomOption": "Özel seçenek ekle",
        "serverNameIndication": "SNI",
        "cipherSuites": "Cipher Suites",
        "autoOption": "Otomatik",
        "minMaxVersion": "Min/Maks sürüm",
        "rejectUnknownSni": "Bilinmeyen SNI reddet",
        "disableSystemRoot": "System Root'u devre dışı bırak",
        "sessionResumption": "Oturum sürdürme",
        "oneTimeLoading": "Tek seferlik yükleme",
        "usageOption": "Kullanım seçeneği",
        "buildChain": "Zincir oluştur",
        "echKey": "ECH key",
        "echConfig": "ECH yapılandırması",
        "pinnedPeerCertSha256": "Sabitlenmiş Peer Sertifikası SHA-256",
        "pinnedPeerCertSha256Tip": "Peer sertifikasının Base64 kodlu SHA-256 hash'leri. Sadece panel — sunucunun xray yapılandırmasına yazılmaz, ancak istemcilerin sertifikayı sabitleyebilmesi için paylaşım bağlantılarına eklenir.",
        "pinnedPeerCertSha256Placeholder": "base64 hash(ler), virgülle ayrılmış",
        "generateRandomPin": "Rastgele hash üret",
        "getNewEchCert": "Yeni ECH sertifikası al",
        "show": "Göster",
        "xver": "Xver",
        "target": "Hedef",
        "maxTimeDiff": "Maks. zaman farkı (ms)",
        "minClientVer": "Min. istemci sürümü",
        "maxClientVer": "Maks. istemci sürümü",
        "shortIds": "Short IDs",
        "spiderX": "SpiderX",
        "getNewCert": "Yeni sertifika al",
        "mldsa65Seed": "mldsa65 Seed",
        "mldsa65Verify": "mldsa65 Verify",
        "getNewSeed": "Yeni Seed al"
      },
      "info": {
        "mode": "Mod",
        "grpcServiceName": "grpc serviceName",
        "grpcMultiMode": "grpc multiMode",
        "interfaceName": "Arabirim adı",
        "mtu": "MTU",
        "gateway": "Gateway",
        "dns": "DNS",
        "outboundsInterface": "Giden arabirimi",
        "autoSystemRoutes": "Otomatik sistem yönlendirmeleri",
        "followRedirect": "FollowRedirect",
        "auth": "Auth",
        "noKernelTun": "Çekirdeksiz TUN",
        "keepAlive": "Keep alive",
        "peerNumber": "Peer {n}",
        "peerNumberConfig": "Peer {n} yapılandırması"
      },
      "stream": {
        "general": {
          "request": "İstek",
          "response": "Yanıt",
          "name": "Ad",
          "value": "Değer"
        },
        "tcp": {
          "version": "Sürüm",
          "method": "Yöntem",
          "path": "Yol",
          "status": "Durum",
          "statusDescription": "Durum Açıklaması",
          "requestHeader": "İstek Başlığı",
          "responseHeader": "Yanıt Başlığı"
        }
      }
    },
    "clients": {
      "add": "İstemci ekle",
      "edit": "İstemciyi düzenle",
      "submitAdd": "İstemci ekle",
      "submitEdit": "Değişiklikleri kaydet",
      "clientCount": "İstemci sayısı",
      "bulk": "Toplu ekle",
      "copyFromInbound": "Inbound'dan istemcileri kopyala",
      "copyToInbound": "İstemcileri kopyalanacak yer",
      "copySelected": "Seçileni kopyala",
      "copySource": "Kaynak",
      "copyEmailPreview": "Oluşacak e-posta önizlemesi",
      "copySelectSourceFirst": "Önce bir kaynak inbound seçin.",
      "copyResult": "Kopya sonucu",
      "copyResultSuccess": "Başarıyla kopyalandı",
      "copyResultNone": "Kopyalanacak bir şey yok: istemci seçilmemiş veya kaynak boş",
      "copyResultErrors": "Kopyalama hataları",
      "copyFlowLabel": "Yeni istemciler için Flow (VLESS)",
      "copyFlowHint": "Kopyalanan tüm istemcilere uygulanır. Atlamak için boş bırakın.",
      "selectAll": "Tümünü seç",
      "clearAll": "Tümünü temizle",
      "method": "Yöntem",
      "first": "İlk",
      "last": "Son",
      "ipLog": "IP günlüğü",
      "prefix": "Önek",
      "postfix": "Sonek",
      "delayedStart": "İlk kullanımdan sonra başla",
      "expireDays": "Süre",
      "days": "Gün",
      "renew": "Otomatik yenileme",
      "renewDesc": "Süre dolduktan sonra otomatik yenileme. (0 = devre dışı) (birim: gün)",
      "searchPlaceholder": "Email, yorum, sub ID, UUID, parola, auth ara…",
      "filterTitle": "İstemcileri filtrele",
      "clearAllFilters": "Tümünü temizle",
      "sortOldest": "Önce en eski",
      "sortNewest": "Önce en yeni",
      "sortRecentlyUpdated": "Son güncellenen",
      "sortRecentlyOnline": "Son zamanlarda çevrimiçi",
      "sortEmailAZ": "Email A→Z",
      "sortEmailZA": "Email Z→A",
      "sortMostTraffic": "En çok trafik",
      "sortHighestRemaining": "En çok kalan",
      "sortExpiringSoonest": "Yakında biten",
      "has": "Var",
      "hasNot": "Yok",
      "title": "İstemciler",
      "actions": "Eylemler",
      "totalGB": "Toplam Gönderilen/Alınan (GB)",
      "expiryTime": "Son kullanma",
      "addClients": "İstemci ekle",
      "limitIp": "IP limiti",
      "password": "Şifre",
      "subId": "Abonelik ID'si",
      "online": "Çevrimiçi",
      "email": "Email",
      "group": "Grup",
      "groupDesc": "İlgili istemcileri gruplamak için mantıksal etiket (ekip, müşteri, bölge). Araç çubuğundan filtrelenebilir.",
      "groupPlaceholder": "örn. customer-a",
      "comment": "Yorum",
      "traffic": "Trafik",
      "offline": "Çevrimdışı",
      "addTitle": "İstemci ekle",
      "qrCode": "QR kodu",
      "moreInformation": "Daha fazla bilgi",
      "delete": "Sil",
      "reset": "Trafiği sıfırla",
      "editTitle": "İstemciyi düzenle",
      "client": "İstemci",
      "enabled": "Etkin",
      "remaining": "Kalan",
      "duration": "Süre",
      "attachedInbounds": "Bağlı inbound'lar",
      "selectInbound": "Bir veya daha fazla inbound seçin",
      "noSubId": "Bu istemcinin subId'si yok, paylaşılabilir bağlantı yok.",
      "noLinks": "Paylaşılabilir bağlantı yok — önce bu istemciyi protokol destekli bir inbound'a bağlayın.",
      "link": "Bağlantı",
      "resetNotPossible": "Önce bu istemciyi bir inbound'a bağlayın.",
      "general": "Genel",
      "resetAllTraffics": "Tüm istemcilerin trafiğini sıfırla",
      "resetAllTrafficsTitle": "Tüm istemcilerin trafiği sıfırlansın mı?",
      "resetAllTrafficsContent": "Her istemcinin yükleme/indirme sayaçları sıfırlanır. Kotalar ve son kullanma tarihleri etkilenmez. Geri alınamaz.",
      "deleteConfirmTitle": "{email} istemcisi silinsin mi?",
      "deleteConfirmContent": "Bu işlem istemciyi bağlı tüm inbound'lardan kaldırır ve trafik kaydını siler. Geri alınamaz.",
      "deleteSelected": "Sil ({count})",
      "adjustSelected": "Ayarla ({count})",
      "subLinksSelected": "Abonelik bağlantıları ({count})",
      "addToGroupTitle": "{count} istemciyi bir gruba ekle",
      "addToGroupTooltip": "Mevcut bir grubu seçin veya yeni ad girin. İstemcileri mevcut gruplarından çıkarmak için Ungroup'u kullanın.",
      "addToGroupPlaceholder": "Grup adı",
      "addToGroupSuccessToast": "{count} istemci {group} grubuna eklendi",
      "ungroupSuccessToast": "{count} istemcinin grubu temizlendi",
      "ungroup": "Gruptan çıkar",
      "ungroupConfirmTitle": "{count} istemciyi gruptan çıkar?",
      "ungroupConfirmContent": "Seçilen her istemcinin grup etiketini temizler. İstemciler korunur (tamamen kaldırmak için Delete kullanın).",
      "addToGroup": "Gruba ekle",
      "attach": "Bağla",
      "adjust": "Ayarla",
      "subLinks": "Abonelik bağlantıları",
      "selectedCount": "{count} seçildi",
      "attachSelected": "Bağla ({count})",
      "attachToInboundsTitle": "{count} istemciyi gelen(ler)e bağla",
      "attachToInboundsDesc": "Seçilen {count} istemciyi (aynı UUID/parola ve paylaşılan trafik) seçilen gelene bağlar. Mevcut bağlantılar korunur.",
      "attachToInboundsTargets": "Hedef gelenler",
      "attachToInboundsNoTargets": "Bağlanacak çoklu kullanıcılı gelen yok.",
      "detachSelected": "Çöz ({count})",
      "detach": "Çöz",
      "detachFromInboundsTitle": "{count} istemciyi gelen(ler)den çöz",
      "detachFromInboundsDesc": "Seçilen {count} istemciyi seçilen gelenden kaldırır. İstemcinin bağlı olmadığı çiftler sessizce atlanır. İstemci kayıtları korunur (tamamen kaldırmak için Delete kullanın).",
      "detachFromInboundsTargets": "Çözülecek gelenler",
      "detachFromInboundsNoTargets": "Çoklu kullanıcılı gelen yok.",
      "detachFromInboundsResult": "Çözüldü {detached}, atlandı {skipped}.",
      "detachFromInboundsResultMixed": "Çözüldü {detached}, atlandı {skipped}, hata {errors}.",
      "subLinksTitle": "Abonelik bağlantıları ({count})",
      "subLinkColumn": "Abonelik URL",
      "subJsonLinkColumn": "Abonelik JSON URL",
      "subLinksCopyAll": "Tümünü kopyala",
      "subLinksCopiedAll": "{count} bağlantı kopyalandı",
      "subLinksEmpty": "Seçilen istemcilerin hiçbirinin abonelik ID'si yok.",
      "subLinksDisabled": "Abonelik hizmeti devre dışı.",
      "subLinksDisabledHint": "Bağlantı oluşturmak için Panel Ayarları → Abonelik'ten etkinleştirin.",
      "bulkDeleteConfirmTitle": "{count} istemci silinsin mi?",
      "bulkDeleteConfirmContent": "Seçili her istemci bağlı tüm inbound'lardan kaldırılır ve trafik kaydı silinir. Geri alınamaz.",
      "bulkAdjustTitle": "{count} istemciyi ayarla",
      "bulkAdjustHint": "Pozitif değerler ekler, negatif değerler azaltır. Sınırsız süreli veya trafikli istemciler ilgili alan için atlanır.",
      "bulkAdjustNothing": "Uygulamadan önce gün veya trafik belirleyin.",
      "addDays": "Gün ekle",
      "addTrafficGB": "Trafik ekle (GB)",
      "delDepleted": "Tükenmişleri sil",
      "delDepletedConfirmTitle": "Tükenmiş istemciler silinsin mi?",
      "delDepletedConfirmContent": "Trafik kotası dolan veya süresi geçen tüm istemciler silinir. Geri alınamaz.",
      "auth": "Auth",
      "hysteriaAuth": "Hysteria Auth",
      "uuid": "UUID",
      "flow": "Flow",
      "vmessSecurity": "VMess Güvenlik",
      "reverseTag": "Reverse tag",
      "reverseTagPlaceholder": "İsteğe bağlı Reverse tag",
      "telegramId": "Telegram kullanıcı ID'si",
      "telegramIdPlaceholder": "Sayısal Telegram kullanıcı ID'si (0 = yok)",
      "created": "Oluşturuldu",
      "updated": "Güncellendi",
      "ipLimit": "IP limiti",
      "toasts": {
        "deleted": "İstemci silindi",
        "trafficReset": "Trafik sıfırlandı",
        "allTrafficsReset": "Tüm istemcilerin trafiği sıfırlandı",
        "bulkDeleted": "{count} istemci silindi",
        "bulkDeletedMixed": "{ok} silindi, {failed} başarısız",
        "bulkCreated": "{count} istemci oluşturuldu",
        "bulkCreatedMixed": "{ok} oluşturuldu, {failed} başarısız",
        "bulkAdjusted": "{count} istemci ayarlandı",
        "bulkAdjustedMixed": "{ok} ayarlandı, {skipped} atlandı",
        "delDepleted": "{count} tükenmiş istemci silindi"
      }
    },
    "groups": {
      "title": "Gruplar",
      "name": "İsim",
      "clientCount": "Gruptaki istemciler",
      "totalGroups": "Toplam grup",
      "totalGroupedClients": "Grubu olan istemciler",
      "emptyGroups": "Boş gruplar",
      "addGroup": "Grup ekle",
      "createSuccess": "«{name}» grubu oluşturuldu.",
      "rename": "Yeniden adlandır",
      "renameTitle": "{name} yeniden adlandır",
      "renameCollision": "«{name}» adında bir grup zaten var.",
      "renameSuccess": "{count} istemcinin grubu yeniden adlandırıldı.",
      "deleteConfirmTitle": "{name} grubunu sil?",
      "deleteConfirmContent": "Bu, grubu siler ve etiketini {count} istemciden temizler. İstemciler silinmez.",
      "deleteSuccess": "{count} istemcinin grubu temizlendi.",
      "resetTraffic": "Trafiği sıfırla",
      "resetConfirmTitle": "{name} grubunun trafiğini sıfırla?",
      "resetConfirmContent": "Bu, bu gruptaki tüm {count} istemcinin yukarı/aşağı trafiğini sıfırlar.",
      "resetSuccess": "{count} istemcinin trafiği sıfırlandı.",
      "adjustSuccess": "{name} içinde {count} istemci ayarlandı.",
      "emptyForAction": "Bu grupta henüz istemci yok.",
      "deleteGroupOnly": "Grubu sil (istemcileri tut)",
      "deleteClients": "Gruptaki istemcileri sil",
      "deleteClientsConfirmTitle": "{name} içindeki tüm istemcileri sil?",
      "deleteClientsConfirmContent": "Bu, {count} istemciyi trafik kayıtlarıyla birlikte kalıcı olarak siler. Grup etiketi de temizlenir. Geri alınamaz.",
      "deleteClientsSuccess": "{count} istemci silindi.",
      "deleteClientsMixed": "{ok} silindi, {failed} atlandı",
      "addToGroup": "İstemci ekle…",
      "addToGroupTitle": "«{name}» grubuna istemci ekle",
      "addToGroupDesc": "Bu gruba eklemek için istemcileri seçin. Mevcut gelen bağlantıları korunur; yalnızca grup etiketi değişir. Halihazırda bu grupta olan istemciler listelenmez.",
      "addToGroupEmpty": "Eklenecek başka istemci yok.",
      "addToGroupResult": "{count} istemci {name} grubuna eklendi.",
      "removeFromGroup": "İstemci çıkar…",
      "removeFromGroupTitle": "«{name}» grubundan istemci çıkar",
      "removeFromGroupDesc": "Bu gruptan çıkarılacak üyeleri seçin. İstemciler korunur (tamamen kaldırmak için «Gruptaki istemcileri sil» kullanın).",
      "removeFromGroupResult": "{name} grubundan {count} istemci çıkarıldı."
    },
    "nodes": {
      "title": "Düğümler",
      "addNode": "Düğüm Ekle",
      "editNode": "Düğümü düzenle",
      "totalNodes": "Toplam Düğüm",
      "onlineNodes": "Çevrimiçi",
      "offlineNodes": "Çevrimdışı",
      "avgLatency": "Ortalama Gecikme",
      "name": "Ad",
      "namePlaceholder": "ör. de-frankfurt-1",
      "addressPlaceholder": "panel.example.com veya 1.2.3.4",
      "remark": "Açıklama",
      "scheme": "Şema",
      "address": "Adres",
      "port": "Port",
      "basePath": "Base Path",
      "apiToken": "API Token",
      "apiTokenPlaceholder": "Uzak panelin Ayarlar sayfasındaki token",
      "apiTokenHint": "Uzak panel API token'ını Ayarlar → API Token altında gösterir.",
      "regenerate": "Token'ı Yeniden Oluştur",
      "regenerateConfirm": "Yeniden oluşturmak mevcut token'ı geçersiz kılar. Onu kullanan tüm merkezi paneller, güncellenene kadar erişimini kaybeder. Devam edilsin mi?",
      "allowPrivateAddress": "Özel adrese izin ver",
      "allowPrivateAddressHint": "Yalnızca özel ağ veya VPN üzerindeki düğümler için etkinleştir.",
      "enable": "Etkin",
      "status": "Durum",
      "cpu": "CPU",
      "mem": "Bellek",
      "uptime": "Çalışma süresi",
      "latency": "Gecikme",
      "lastHeartbeat": "Son Sinyal",
      "xrayVersion": "Xray Sürümü",
      "panelVersion": "Panel sürümü",
      "actions": "İşlemler",
      "probe": "Şimdi Test Et",
      "testConnection": "Bağlantıyı Test Et",
      "connectionOk": "Bağlantı tamam ({ms} ms)",
      "connectionFailed": "Bağlantı başarısız",
      "never": "asla",
      "justNow": "şimdi",
      "deleteConfirmTitle": "\"{name}\" düğümü silinsin mi?",
      "deleteConfirmContent": "Bu, düğüm izlemeyi durdurur. Uzak panelin kendisi etkilenmez.",
      "statusValues": {
        "online": "Çevrimiçi",
        "offline": "Çevrimdışı",
        "unknown": "Bilinmiyor"
      },
      "toasts": {
        "list": "Düğümler yüklenemedi",
        "obtain": "Düğüm yüklenemedi",
        "add": "Düğüm ekle",
        "update": "Düğümü güncelle",
        "delete": "Düğümü sil",
        "deleted": "Düğüm silindi",
        "test": "Bağlantıyı test et",
        "fillRequired": "Ad, adres, port ve API token gereklidir",
        "probeFailed": "Test başarısız"
      }
    },
    "settings": {
      "title": "Panel Ayarları",
      "save": "Kaydet",
      "infoDesc": "Burada yapılan her değişikliğin kaydedilmesi gerekir. Değişikliklerin uygulanması için paneli yeniden başlatın.",
      "restartPanel": "Paneli yeniden başlat",
      "restartPanelDesc": "Paneli yeniden başlatmak istediğinizden emin misiniz? Yeniden başlattıktan sonra panele erişemezseniz, sunucudaki panel günlük bilgilerini görüntüleyin.",
      "restartPanelSuccess": "Panel başarıyla yeniden başlatıldı",
      "actions": "Eylemler",
      "resetDefaultConfig": "Varsayılana Sıfırla",
      "panelSettings": "Genel",
      "securitySettings": "Kimlik Doğrulama",
      "securityWarnings": "Güvenlik uyarıları",
      "panelExposed": "Paneliniz açıkta olabilir:",
      "warnHttp": "Panel düz HTTP üzerinden sunuluyor — üretim için TLS kurun.",
      "warnDefaultPort": "Varsayılan port 2053 yaygın olarak biliniyor — rastgele bir porta değiştirin.",
      "warnDefaultBasePath": "Varsayılan temel yol \"/\" yaygın olarak biliniyor — rastgele bir yola değiştirin.",
      "warnDefaultSubPath": "Varsayılan abonelik yolu \"/sub/\" yaygın olarak biliniyor — değiştirin.",
      "warnDefaultJsonPath": "Varsayılan JSON abonelik yolu \"/json/\" yaygın olarak biliniyor — değiştirin.",
      "TGBotSettings": "Telegram Bot",
      "panelListeningIP": "Dinleme IP",
      "panelListeningIPDesc": "Web paneli için IP adresi. (tüm IP'leri dinlemek için boş bırakın)",
      "panelListeningDomain": "Dinleme Alan Adı",
      "panelListeningDomainDesc": "Web paneli için alan adı. (tüm alan adlarını ve IP'leri dinlemek için boş bırakın)",
      "panelPort": "Dinleme Portu",
      "panelPortDesc": "Web paneli için port numarası. (kullanılmayan bir port olmalıdır)",
      "publicKeyPath": "Genel Anahtar Yolu",
      "publicKeyPathDesc": "Web paneli için genel anahtar dosya yolu. ('/' ile başlar)",
      "privateKeyPath": "Özel Anahtar Yolu",
      "privateKeyPathDesc": "Web paneli için özel anahtar dosya yolu. ('/' ile başlar)",
      "panelUrlPath": "URI yolu",
      "panelUrlPathDesc": "Web paneli için URI yolu. ('/' ile başlar ve '/' ile biter)",
      "pageSize": "Sayfa Boyutu",
      "pageSizeDesc": "Gelenler tablosu için sayfa boyutunu belirleyin. (0 = devre dışı)",
      "panelProxy": "Panel ağ proxy'si",
      "panelProxyDesc": "Panelin kendi giden istekleri (geo güncellemeleri, Xray/panel sürüm kontrolleri, Telegram) bu proxy üzerinden yönlendirir; sunucu tarafındaki GitHub/Telegram filtrelemesini atlatmak için. socks5:// veya http(s):// kabul eder, örn. yerel bir Xray SOCKS geleni. Doğrudan bağlantı için boş bırakın.",
      "remarkModel": "Açıklama Modeli & Ayırma Karakteri",
      "datepicker": "Takvim Türü",
      "datepickerPlaceholder": "Tarih Seçin",
      "datepickerDescription": "Planlanmış görevler bu takvime göre çalışacaktır.",
      "sampleRemark": "Örnek Açıklama",
      "oldUsername": "Mevcut Kullanıcı Adı",
      "currentPassword": "Mevcut Şifre",
      "newUsername": "Yeni Kullanıcı Adı",
      "newPassword": "Yeni Şifre",
      "telegramBotEnable": "Telegram Botunu Etkinleştir",
      "telegramBotEnableDesc": "Telegram botunu etkinleştirir.",
      "telegramToken": "Telegram Token",
      "telegramTokenDesc": "'{'@'}BotFather'dan alınan Telegram bot token.",
      "telegramProxy": "SOCKS Proxy",
      "telegramProxyDesc": "Telegram'a bağlanmak için SOCKS5 proxy'sini etkinleştirir. (ayarları kılavuzda belirtilen şekilde ayarlayın)",
      "telegramAPIServer": "Telegram API Sunucusu",
      "telegramAPIServerDesc": "Kullanılacak Telegram API sunucusu. Varsayılan sunucuyu kullanmak için boş bırakın.",
      "telegramChatId": "Yönetici Sohbet Kimliği",
      "telegramChatIdDesc": "Telegram Yönetici Sohbet Kimliği(leri). (virgülle ayrılmış)(buradan alın {'@'}userinfobot) veya (botta '/id' komutunu kullanın)",
      "telegramNotifyTime": "Bildirim Zamanı",
      "telegramNotifyTimeDesc": "Periyodik raporlar için ayarlanan Telegram bot bildirim zamanı. (crontab zaman formatını kullanın)",
      "tgNotifyBackup": "Veritabanı Yedeği",
      "tgNotifyBackupDesc": "Bir rapor ile birlikte veritabanı yedek dosyasını gönder.",
      "tgNotifyLogin": "Giriş Bildirimi",
      "tgNotifyLoginDesc": "Birisi web panelinize giriş yapmaya çalıştığında kullanıcı adı, IP adresi ve zaman hakkında bildirim alın.",
      "sessionMaxAge": "Oturum Süresi",
      "sessionMaxAgeDesc": "Giriş yaptıktan sonra oturum süresi. (birim: dakika)",
      "expireTimeDiff": "Son Kullanma Tarihi Bildirimi",
      "expireTimeDiffDesc": "Bu eşik seviyesine ulaşıldığında son kullanma tarihi hakkında bildirim alın. (birim: gün)",
      "trafficDiff": "Trafik Sınırı Bildirimi",
      "trafficDiffDesc": "Bu eşik seviyesine ulaşıldığında trafik sınırı hakkında bildirim alın. (birim: GB)",
      "tgNotifyCpu": "CPU Yükü Bildirimi",
      "tgNotifyCpuDesc": "CPU yükü bu eşik seviyesini aşarsa bildirim alın. (birim: %)",
      "timeZone": "Saat Dilimi",
      "timeZoneDesc": "Planlanmış görevler bu saat dilimine göre çalışacaktır.",
      "subSettings": "Abonelik",
      "subEnable": "Abonelik Hizmetini Etkinleştir",
      "subEnableDesc": "Abonelik hizmetini etkinleştirir.",
      "subJsonEnable": "JSON abonelik uç noktasını bağımsız olarak Etkinleştir/Devre Dışı bırak.",
      "subJsonEnableTitle": "JSON aboneliği",
      "subClashEnableTitle": "Clash / Mihomo aboneliği",
      "subTitle": "Abonelik Başlığı",
      "subTitleDesc": "VPN istemcisinde gösterilen başlık",
      "subSupportUrl": "Destek URL'si",
      "subSupportUrlDesc": "VPN istemcisinde gösterilen teknik destek bağlantısı",
      "subProfileUrl": "Profil URL'si",
      "subProfileUrlDesc": "VPN istemcisinde görüntülenen web sitenize giden bağlantı",
      "subAnnounce": "Duyuru",
      "subAnnounceDesc": "VPN istemcisinde görüntülenen duyuru metni",
      "subEnableRouting": "Yönlendirmeyi etkinleştir",
      "subEnableRoutingDesc": "VPN istemcisinde yönlendirmeyi etkinleştirmek için genel ayar. (Yalnızca Happ için)",
      "subRoutingRules": "Yönlendirme kuralları",
      "subRoutingRulesDesc": "VPN istemcisi için genel yönlendirme kuralları. (Yalnızca Happ için)",
      "subListen": "Dinleme IP",
      "subListenDesc": "Abonelik hizmeti için IP adresi. (tüm IP'leri dinlemek için boş bırakın)",
      "subPort": "Dinleme Portu",
      "subPortDesc": "Abonelik hizmeti için port numarası. (kullanılmayan bir port olmalıdır)",
      "subCertPath": "Genel Anahtar Yolu",
      "subCertPathDesc": "Abonelik hizmeti için genel anahtar dosya yolu. ('/' ile başlar)",
      "subKeyPath": "Özel Anahtar Yolu",
      "subKeyPathDesc": "Abonelik hizmeti için özel anahtar dosya yolu. ('/' ile başlar)",
      "subPath": "URI yolu",
      "subPathDesc": "Abonelik hizmeti için URI yolu. ('/' ile başlar ve '/' ile biter)",
      "subDomain": "Dinleme Alan Adı",
      "subDomainDesc": "Abonelik hizmeti için alan adı. (tüm alan adlarını ve IP'leri dinlemek için boş bırakın)",
      "subUpdates": "Güncelleme Aralıkları",
      "subUpdatesDesc": "Müşteri uygulamalarındaki abonelik URL'sinin güncelleme aralıkları. (birim: saat)",
      "subEncrypt": "Kodla",
      "subEncryptDesc": "Abonelik hizmetinin döndürülen içeriği Base64 ile şifrelenir.",
      "subShowInfo": "Kullanım Bilgisini Göster",
      "subShowInfoDesc": "Kalan trafik ve tarih müşteri uygulamalarında görüntülenir.",
      "subEmailInRemark": "Ada Email Ekle",
      "subEmailInRemarkDesc": "Abonelik profil adına istemcinin e-postasını dahil edin.",
      "subURI": "Ters Proxy URI",
      "subURIDesc": "Proxy arkasında kullanılacak abonelik URL'sinin URI yolu.",
      "externalTrafficInformEnable": "Harici Trafik Bilgisi",
      "externalTrafficInformEnableDesc": "Her trafik güncellemesinde harici API'yi bilgilendir.",
      "externalTrafficInformURI": "Harici Trafik Bilgisi URI'si",
      "externalTrafficInformURIDesc": "Trafik güncellemeleri bu URI'ye gönderildi.",
      "restartXrayOnClientDisable": "Otomatik Devre Dışı Sonrası Xray'i Yeniden Başlat",
      "restartXrayOnClientDisableDesc": "Bir istemci süre dolumu veya trafik limiti nedeniyle otomatik devre dışı bırakıldığında Xray'i yeniden başlat.",
      "fragment": "Parçalama",
      "fragmentDesc": "TLS merhaba paketinin parçalanmasını etkinleştir.",
      "fragmentSett": "Parçalama Ayarları",
      "noisesDesc": "Noises'i Etkinleştir.",
      "noisesSett": "Noises Ayarları",
      "trustedProxyCidrs": "Güvenilir proxy CIDR'leri",
      "trustedProxyCidrsDesc": "İletilen host, proto ve istemci IP başlıklarını ayarlamasına izin verilen IP'ler/CIDR'ler (virgülle ayrılmış).",
      "ldap": {
        "enable": "LDAP senkronizasyonunu etkinleştir",
        "host": "LDAP host",
        "port": "LDAP port",
        "useTls": "TLS kullan (LDAPS)",
        "bindDn": "Bind DN",
        "passwordConfigured": "Yapılandırıldı; mevcut parolayı korumak için boş bırakın.",
        "passwordUnconfigured": "Yapılandırılmadı.",
        "passwordPlaceholder": "Yapılandırıldı — değiştirmek için yeni değer girin",
        "baseDn": "Base DN",
        "userFilter": "Kullanıcı filtresi",
        "userAttr": "Kullanıcı özniteliği (username/email)",
        "vlessField": "VLESS flag özniteliği",
        "flagField": "Genel flag özniteliği (opsiyonel)",
        "flagFieldDesc": "Ayarlanırsa VLESS flag'ini geçersiz kılar — örn. shadowInactive.",
        "truthyValues": "Truthy değerler",
        "truthyValuesDesc": "Virgülle ayrılmış; varsayılan: true,1,yes,on",
        "invertFlag": "Flag'i tersine çevir",
        "invertFlagDesc": "Öznitelik «devre dışı» anlamına geldiğinde etkinleştirin (örn. shadowInactive).",
        "syncSchedule": "Senkronizasyon programı",
        "syncScheduleDesc": "cron benzeri dize, örn. @every 1m",
        "inboundTags": "Gelen etiketleri",
        "inboundTagsDesc": "LDAP senkronizasyonunun istemci otomatik oluşturup/silebileceği gelenler.",
        "noInbounds": "Gelen bulunamadı. Önce Gelenler'de bir tane oluşturun.",
        "autoCreate": "İstemcileri otomatik oluştur",
        "autoDelete": "İstemcileri otomatik sil",
        "defaultTotalGb": "Varsayılan toplam (GB)",
        "defaultExpiryDays": "Varsayılan son kullanma (gün)",
        "defaultIpLimit": "Varsayılan IP limiti"
      },
      "subFormats": {
        "packets": "Paketler",
        "length": "Uzunluk",
        "interval": "Aralık",
        "maxSplit": "Maks. bölünme",
        "noises": "Gürültüler",
        "noiseItem": "Gürültü №{n}",
        "type": "Tip",
        "packet": "Paket",
        "delayMs": "Gecikme (ms)",
        "applyTo": "Şuna uygula",
        "addNoise": "+ Gürültü",
        "concurrency": "Eşzamanlılık",
        "xudpConcurrency": "xudp eşzamanlılık",
        "xudpUdp443": "xudp UDP 443"
      },
      "mux": "Mux",
      "muxDesc": "Kurulmuş bir veri akışında birden çok bağımsız veri akışını iletir.",
      "muxSett": "Mux Ayarları",
      "direct": "Doğrudan Bağlantı",
      "directDesc": "Belirli bir ülkenin alan adları veya IP aralıkları ile doğrudan bağlantı kurar.",
      "notifications": "Bildirimler",
      "certs": "Sertifikalar",
      "externalTraffic": "Harici Trafik",
      "dateAndTime": "Tarih ve Saat",
      "proxyAndServer": "Proxy ve Sunucu",
      "intervals": "Aralıklar",
      "information": "Bilgi",
      "language": "Dil",
      "telegramBotLanguage": "Telegram Bot Dili",
      "security": {
        "admin": "Yönetici kimlik bilgileri",
        "twoFactor": "İki adımlı doğrulama",
        "twoFactorEnable": "2FA'yı Etkinleştir",
        "twoFactorEnableDesc": "Daha fazla güvenlik için ek bir doğrulama katmanı ekler.",
        "twoFactorModalSetTitle": "İki adımlı doğrulamayı etkinleştir",
        "twoFactorModalDeleteTitle": "İki adımlı doğrulamayı devre dışı bırak",
        "twoFactorModalSteps": "İki adımlı doğrulamayı ayarlamak için şu adımları izleyin:",
        "twoFactorModalFirstStep": "1. Bu QR kodunu doğrulama uygulamasında tarayın veya QR kodunun yanındaki token'ı kopyalayıp uygulamaya yapıştırın",
        "twoFactorModalSecondStep": "2. Uygulamadaki kodu girin",
        "twoFactorModalRemoveStep": "İki adımlı doğrulamayı kaldırmak için uygulamadaki kodu girin.",
        "twoFactorModalChangeCredentialsTitle": "Kimlik bilgilerini değiştir",
        "twoFactorModalChangeCredentialsStep": "Yönetici kimlik bilgilerini değiştirmek için uygulamadaki kodu girin.",
        "twoFactorModalSetSuccess": "İki faktörlü kimlik doğrulama başarıyla kuruldu",
        "twoFactorModalDeleteSuccess": "İki faktörlü kimlik doğrulama başarıyla silindi",
        "twoFactorModalError": "Yanlış kod",
        "show": "Göster",
        "hide": "Gizle",
        "apiTokenNew": "Yeni token",
        "apiTokenName": "Ad",
        "apiTokenNamePlaceholder": "örn. central-panel-a",
        "apiTokenNameRequired": "Ad zorunludur",
        "apiTokenEmpty": "Henüz token yok — bot veya uzak panelleri doğrulamak için bir tane oluşturun.",
        "apiTokenDeleteWarning": "Bu tokenı kullanan tüm istemciler anında kimlik doğrulamasını kaybeder."
      },
      "toasts": {
        "modifySettings": "Parametreler değiştirildi.",
        "getSettings": "Parametreler alınırken bir hata oluştu.",
        "modifyUserError": "Yönetici kimlik bilgileri değiştirilirken bir hata oluştu.",
        "modifyUser": "Yönetici kimlik bilgilerini başarıyla değiştirdiniz.",
        "originalUserPassIncorrect": "Mevcut kullanıcı adı veya şifre geçersiz",
        "userPassMustBeNotEmpty": "Yeni kullanıcı adı ve şifre boş olamaz",
        "getOutboundTrafficError": "Giden trafik alınırken hata",
        "resetOutboundTrafficError": "Giden trafik sıfırlanırken hata"
      }
    },
    "xray": {
      "title": "Xray Yapılandırmaları",
      "save": "Kaydet",
      "restart": "Xray'i yeniden başlat",
      "restartSuccess": "Xray başarıyla yeniden başlatıldı",
      "restartOutputTitle": "Xray yeniden başlatma çıktısı",
      "restartConfirmTitle": "Xray'i yeniden başlat?",
      "restartConfirmContent": "Xray hizmeti kaydedilmiş yapılandırma ile yeniden yüklenir.",
      "stopSuccess": "Xray başarıyla durduruldu",
      "restartError": "Xray yeniden başlatılırken bir hata oluştu.",
      "stopError": "Xray durdurulurken bir hata oluştu.",
      "basicTemplate": "Temeller",
      "advancedTemplate": "Gelişmiş",
      "generalConfigs": "Genel",
      "generalConfigsDesc": "Bu seçenekler genel ayarlamaları belirler.",
      "logConfigs": "Günlük",
      "logConfigsDesc": "Günlükler sunucunuzun verimliliğini etkileyebilir. Yalnızca ihtiyaç durumunda akıllıca etkinleştirmeniz önerilir",
      "blockConfigsDesc": "Bu seçenekler belirli istek protokolleri ve web siteleri temelinde trafiği engeller.",
      "basicRouting": "Temel Yönlendirme",
      "blockConnectionsConfigsDesc": "Bu seçenekler belirli bir istenen ülkeye göre trafiği engelleyecektir.",
      "directConnectionsConfigsDesc": "Doğrudan bağlantı, belirli bir trafiğin başka bir sunucu üzerinden yönlendirilmediğini sağlar.",
      "blockips": "IP'leri Engelle",
      "blockdomains": "Alan Adlarını Engelle",
      "directips": "Doğrudan IP'ler",
      "directdomains": "Doğrudan Alan Adları",
      "ipv4Routing": "IPv4 Yönlendirme",
      "ipv4RoutingDesc": "Bu seçenekler belirli bir varış yerine IPv4 üzerinden trafiği yönlendirir.",
      "warpRouting": "WARP Yönlendirme",
      "warpRoutingDesc": "Bu seçenekler belirli bir varış yerine WARP üzerinden trafiği yönlendirir.",
      "nordRouting": "NordVPN Yönlendirme",
      "nordRoutingDesc": "Bu seçenekler belirli bir varış yerine NordVPN üzerinden trafiği yönlendirir.",
      "Template": "Gelişmiş Xray Yapılandırma Şablonu",
      "TemplateDesc": "Nihai Xray yapılandırma dosyası bu şablona göre oluşturulacaktır.",
      "FreedomStrategy": "Freedom Protokol Stratejisi",
      "FreedomStrategyDesc": "Freedom Protokolünde ağın çıkış stratejisini ayarlayın.",
      "RoutingStrategy": "Genel Yönlendirme Stratejisi",
      "RoutingStrategyDesc": "Tüm istekleri çözmek için genel trafik yönlendirme stratejisini ayarlayın.",
      "outboundTestUrl": "Outbound test URL",
      "outboundTestUrlDesc": "Outbound bağlantı testinde kullanılan URL",
      "Torrent": "BitTorrent Protokolünü Engelle",
      "Inbounds": "Gelenler",
      "InboundsDesc": "Belirli müşterileri kabul eder.",
      "Outbounds": "Gidenler",
      "Balancers": "Dengeler",
      "balancerTagRequired": "Etiket gereklidir",
      "balancerSelectorRequired": "En az bir giden seçin",
      "OutboundsDesc": "Giden trafiğin yolunu ayarlayın.",
      "Routings": "Yönlendirme Kuralları",
      "RoutingsDesc": "Her kuralın önceliği önemlidir!",
      "completeTemplate": "Tümü",
      "logLevel": "Günlük Seviyesi",
      "logLevelDesc": "Hata günlükleri için günlük seviyesi, kaydedilmesi gereken bilgileri belirtir.",
      "accessLog": "Erişim Günlüğü",
      "accessLogDesc": "Erişim günlüğü için dosya yolu. 'none' özel değeri erişim günlüklerini devre dışı bırakır",
      "errorLog": "Hata Günlüğü",
      "errorLogDesc": "Hata günlüğü için dosya yolu. 'none' özel değeri hata günlüklerini devre dışı bırakır",
      "dnsLog": "DNS Günlüğü",
      "dnsLogDesc": "DNS sorgu günlüklerini etkinleştirin",
      "maskAddress": "Adres Maskesi",
      "maskAddressDesc": "IP adresi maskesi, etkinleştirildiğinde, günlükte görünen IP adresini otomatik olarak değiştirecektir.",
      "statistics": "İstatistikler",
      "statsInboundUplink": "Gelen Yükleme İstatistikleri",
      "statsInboundUplinkDesc": "Tüm gelen proxy'lerin yükleme trafiği için istatistik toplamayı etkinleştirir.",
      "statsInboundDownlink": "Gelen İndirme İstatistikleri",
      "statsInboundDownlinkDesc": "Tüm gelen proxy'lerin indirme trafiği için istatistik toplamayı etkinleştirir.",
      "statsOutboundUplink": "Giden Yükleme İstatistikleri",
      "statsOutboundUplinkDesc": "Tüm giden proxy'lerin yükleme trafiği için istatistik toplamayı etkinleştirir.",
      "statsOutboundDownlink": "Giden İndirme İstatistikleri",
      "statsOutboundDownlinkDesc": "Tüm giden proxy'lerin indirme trafiği için istatistik toplamayı etkinleştirir.",
      "rules": {
        "first": "İlk",
        "last": "Son",
        "up": "Yukarı",
        "down": "Aşağı",
        "source": "Kaynak",
        "dest": "Hedef",
        "inbound": "Gelen",
        "outbound": "Giden",
        "balancer": "Dengeler",
        "info": "Bilgi",
        "add": "Kural Ekle",
        "edit": "Kuralı Düzenle",
        "useComma": "Virgülle ayrılmış öğeler"
      },
      "routing": {
        "dragToReorder": "Yeniden sıralamak için sürükleyin"
      },
      "ruleForm": {
        "sourceIps": "Kaynak IP'ler",
        "sourcePort": "Kaynak port",
        "vlessRoute": "VLESS rotası",
        "attributes": "Öznitelikler",
        "value": "Değer",
        "user": "Kullanıcı",
        "inboundTags": "Gelen etiketleri",
        "outboundTag": "Giden etiketi",
        "balancerTag": "Dengeleyici etiketi",
        "balancerTagTooltip": "Trafiği yapılandırılmış yük dengeleyicilerden biri üzerinden yönlendirir"
      },
      "outboundForm": {
        "tagDuplicate": "Etiket başka bir giden tarafından kullanılıyor",
        "tagRequired": "Etiket gereklidir",
        "tagPlaceholder": "benzersiz-etiket",
        "localIpPlaceholder": "yerel IP",
        "addressRequired": "Adres gereklidir",
        "portRequired": "Port gereklidir",
        "optional": "opsiyonel",
        "udpOverTcp": "UDP over TCP",
        "uotVersion": "UoT sürümü",
        "inboundTag": "Gelen etiketi",
        "inboundTagPlaceholder": "yönlendirme kurallarında kullanılan gelen etiketi",
        "responseType": "Yanıt tipi",
        "rewriteNetwork": "Ağı yeniden yaz",
        "unchanged": "(değişmedi)",
        "unchangedAddress": "(değişmedi) örn. 1.1.1.1",
        "rules": "Kurallar",
        "ruleN": "Kural {n}",
        "action": "Eylem",
        "redirect": "Redirect",
        "fragment": "Fragment",
        "finalRules": "Nihai kurallar",
        "overrideXrayPrivateIp": "Xray'in varsayılan özel IP bloğunu geçersiz kıl",
        "blockDelay": "Engelleme gecikmesi (ms)",
        "reverseSniffing": "Ters sniffing",
        "workers": "Workers",
        "reserved": "Ayrılmış",
        "minUploadInterval": "Min. yükleme aralığı (ms)",
        "maxUploadSizeBytes": "Maks. yükleme boyutu (bayt)",
        "uplinkChunkSize": "Uplink chunk boyutu",
        "noGrpcHeader": "gRPC başlığı yok",
        "maxConcurrency": "Maks. eşzamanlılık",
        "maxConnections": "Maks. bağlantı",
        "maxReuseTimes": "Maks. yeniden kullanım",
        "maxRequestTimes": "Maks. istek sayısı",
        "maxReusableSecs": "Maks. yeniden kullanılabilir saniye",
        "keepAlivePeriod": "Keep alive periyodu",
        "authPassword": "Auth parolası",
        "visionTestpre": "Vision testpre",
        "serverNamePlaceholder": "sunucu adı",
        "verifyPeerName": "Peer adını doğrula",
        "pinnedSha256": "Pinned SHA256",
        "shortId": "Short ID",
        "sockopts": "Sockopts",
        "keepAliveInterval": "Keep alive aralığı",
        "markFwmark": "Mark (fwmark)",
        "interface": "Arabirim",
        "ipv6Only": "Yalnızca IPv6",
        "acceptProxyProtocol": "Proxy protocol kabul et",
        "tcpUserTimeoutMs": "TCP user timeout (ms)",
        "tcpKeepAliveIdleS": "TCP keep-alive idle (s)"
      },
      "outbound": {
        "addOutbound": "Giden Ekle",
        "addReverse": "Ters Ekle",
        "editOutbound": "Gideni Düzenle",
        "editReverse": "Tersi Düzenle",
        "reverseTag": "Ters Etiket",
        "reverseTagDesc": "VLESS basit ters proxy çıkış etiketi. Devre dışı bırakmak için boş bırakın.",
        "reverseTagPlaceholder": "çıkış etiketi (boş = devre dışı)",
        "tag": "Etiket",
        "tagDesc": "Benzersiz Etiket",
        "address": "Adres",
        "reverse": "Ters",
        "domain": "Alan adı",
        "type": "Tür",
        "bridge": "Bridge",
        "portal": "Portal",
        "link": "Bağlantı",
        "intercon": "Bağlantı",
        "settings": "Ayarlar",
        "accountInfo": "Hesap Bilgileri",
        "outboundStatus": "Giden Durumu",
        "sendThrough": "Üzerinden Gönder",
        "test": "Test",
        "testResult": "Test Sonucu",
        "testing": "Bağlantı test ediliyor...",
        "testSuccess": "Test başarılı",
        "testFailed": "Test başarısız",
        "testError": "Giden test edilemedi",
        "testModeTooltip": "TCP: hızlı dial-only probe. HTTP: xray üzerinden tam istek.",
        "testAll": "Tümünü test et",
        "nordvpn": "NordVPN",
        "accessToken": "Erişim Jetonu",
        "country": "Ülke",
        "server": "Sunucu",
        "city": "Şehir",
        "allCities": "Tüm Şehirler",
        "privateKey": "Özel Anahtar",
        "load": "Yük"
      },
      "balancer": {
        "addBalancer": "Dengeleyici Ekle",
        "editBalancer": "Dengeleyiciyi Düzenle",
        "balancerStrategy": "Strateji",
        "balancerSelectors": "Seçiciler",
        "tag": "Etiket",
        "tagDesc": "Benzersiz Etiket",
        "tagDuplicate": "Etiket başka bir dengeleyici tarafından kullanılıyor",
        "tagPlaceholder": "benzersiz dengeleyici etiketi",
        "selector": "Seçici",
        "fallback": "Fallback",
        "expected": "Beklenen",
        "expectedPlaceholder": "optimal düğüm sayısı",
        "maxRtt": "Maks. RTT",
        "tolerance": "Tolerans",
        "baselines": "Baselines",
        "costs": "Costs",
        "balancerDesc": "Dengeleyici Etiketi ve Giden Etiketi aynı anda kullanılamaz. Aynı anda kullanıldığında yalnızca giden etiketi çalışır."
      },
      "wireguard": {
        "secretKey": "Gizli Anahtar",
        "publicKey": "Genel Anahtar",
        "allowedIPs": "İzin Verilen IP'ler",
        "endpoint": "Uç Nokta",
        "psk": "Ön Paylaşılan Anahtar",
        "domainStrategy": "Alan Adı Stratejisi"
      },
      "tun": {
        "nameDesc": "TUN arabiriminin adı. Varsayılan değer 'xray0'dir",
        "mtuDesc": "Maksimum İletim Birimi. Veri paketlerinin maksimum boyutu. Varsayılan değer 1500'dür",
        "userLevel": "Kullanıcı Seviyesi",
        "userLevelDesc": "Bu giriş yoluyla yapılan tüm bağlantılar bu kullanıcı seviyesini kullanacaktır. Varsayılan değer 0'dır"
      },
      "nord": {
        "accessToken": "Access token",
        "privateKey": "Özel anahtar",
        "noServers": "Seçilen ülke için sunucu bulunamadı",
        "noPublicKey": "Seçilen sunucu NordLynx genel anahtarı yayınlamıyor.",
        "outboundAdded": "NordVPN giden eklendi",
        "outboundUpdated": "NordVPN giden güncellendi"
      },
      "warp": {
        "licenseError": "WARP lisansı ayarlanamadı.",
        "fetchFirst": "Önce WARP yapılandırmasını alın.",
        "createAccount": "WARP hesabı oluştur",
        "accessToken": "Access token",
        "deviceId": "Cihaz ID",
        "licenseKey": "Lisans anahtarı",
        "privateKey": "Özel anahtar",
        "deleteAccount": "Hesabı sil",
        "settings": "Ayarlar",
        "licenseKeyLabel": "WARP / WARP+ lisans anahtarı",
        "key": "Anahtar",
        "keyPlaceholder": "26 karakterli WARP+ anahtarı",
        "accountInfo": "Hesap bilgisi",
        "deviceName": "Cihaz adı",
        "deviceModel": "Cihaz modeli",
        "deviceEnabled": "Cihaz etkin",
        "accountType": "Hesap tipi",
        "role": "Rol",
        "warpPlusData": "WARP+ veri",
        "quota": "Kota",
        "usage": "Kullanım",
        "addOutbound": "Giden ekle"
      },
      "dns": {
        "enable": "DNS'yi Etkinleştir",
        "enableDesc": "Dahili DNS sunucusunu etkinleştir",
        "tag": "DNS Gelen Etiketi",
        "tagDesc": "Bu etiket, yönlendirme kurallarında Gelen etiketi olarak kullanılabilir.",
        "clientIp": "İstemci IP",
        "clientIpDesc": "DNS sorguları sırasında belirtilen IP konumunu sunucuya bildirmek için kullanılır",
        "disableCache": "Önbelleği devre dışı bırak",
        "disableCacheDesc": "DNS önbelleğini devre dışı bırakır",
        "disableFallback": "Yedeklemeyi devre dışı bırak",
        "disableFallbackDesc": "Yedek DNS sorgularını devre dışı bırakır",
        "disableFallbackIfMatch": "Eşleşirse Yedeklemeyi Devre Dışı Bırak",
        "disableFallbackIfMatchDesc": "DNS sunucusunun eşleşen alan adı listesi vurulduğunda yedek DNS sorgularını devre dışı bırakır",
        "enableParallelQuery": "Paralel Sorguyu Etkinleştir",
        "enableParallelQueryDesc": "Daha hızlı çözümleme için birden fazla sunucuya paralel DNS sorgularını etkinleştir",
        "strategy": "Sorgu Stratejisi",
        "strategyDesc": "Alan adlarını çözmek için genel strateji",
        "add": "Sunucu Ekle",
        "edit": "Sunucuyu Düzenle",
        "domains": "Alan adları",
        "expectIPs": "Beklenen IP'ler",
        "unexpectIPs": "Beklenmeyen IP'ler",
        "useSystemHosts": "Sistem Hosts'larını Kullan",
        "useSystemHostsDesc": "Yüklü bir sistemden hosts dosyasını kullan",
        "serveStale": "Süresi Dolmuş Sonuçları Sun",
        "serveStaleDesc": "Arka planda yenilenirken süresi dolmuş önbellek sonuçlarını döndür",
        "serveExpiredTTL": "Süresi Dolmuş TTL",
        "serveExpiredTTLDesc": "Süresi dolmuş önbellek girdilerinin geçerlilik süresi (saniye); 0 = asla",
        "timeoutMs": "Zaman aşımı (ms)",
        "skipFallback": "Yedekleri Atla",
        "finalQuery": "Son Sorgu",
        "hosts": "Hosts",
        "hostsAdd": "Host Ekle",
        "hostsEmpty": "Tanımlı Host yok",
        "hostsDomain": "Alan adı (ör. domain:example.com)",
        "hostsValues": "IP veya alan adı — yazıp Enter'a basın",
        "usePreset": "Şablon kullan",
        "dnsPresetTitle": "DNS Şablonları",
        "dnsPresetFamily": "Aile",
        "clearAll": "Tümünü Sil",
        "clearAllTitle": "Tüm DNS sunucularını sil?",
        "clearAllConfirm": "Bu, tüm DNS sunucularını listeden kaldırır. Geri alınamaz."
      },
      "fakedns": {
        "add": "Sahte DNS Ekle",
        "edit": "Sahte DNS'i Düzenle",
        "ipPool": "IP Havuzu Alt Ağı",
        "poolSize": "Havuz Boyutu"
      }
    }
  },
  "tgbot": {
    "keyboardClosed": "❌ Klavye kapatıldı!",
    "noResult": "❗ Sonuç yok!",
    "noQuery": "❌ Sorgu bulunamadı! Lütfen komutu tekrar kullanın!",
    "wentWrong": "❌ Bir şeyler yanlış gitti!",
    "noIpRecord": "❗ IP Kaydı Yok!",
    "noInbounds": "❗ Gelen bağlantı bulunamadı!",
    "unlimited": "♾ Sınırsız (Sıfırla)",
    "add": "Ekle",
    "month": "Ay",
    "months": "Aylar",
    "day": "Gün",
    "days": "Günler",
    "hours": "Saatler",
    "minutes": "Dakika",
    "unknown": "Bilinmeyen",
    "inbounds": "Gelenler",
    "clients": "İstemciler",
    "offline": "🔴 Çevrimdışı",
    "online": "🟢 Çevrimiçi",
    "commands": {
      "unknown": "❗ Bilinmeyen komut.",
      "pleaseChoose": "👇 Lütfen seçin:\r\n",
      "help": "🤖 Bu bota hoş geldiniz! Web panelinden belirli verileri sunmak ve gerektiğinde değişiklik yapmanıza olanak tanımak için tasarlanmıştır.\r\n\r\n",
      "start": "👋 Merhaba <i>{{ .Firstname }}</i>.\r\n",
      "welcome": "🤖 <b>{{ .Hostname }}</b> yönetim botuna hoş geldiniz.\r\n",
      "status": "✅ Bot çalışıyor!",
      "usage": "❗ Lütfen aramak için bir metin sağlayın!",
      "getID": "🆔 Kimliğiniz: <code>{{ .ID }}</code>",
      "helpAdminCommands": "Xray Core'u yeniden başlatmak için:\r\n<code>/restart</code>\r\n\r\nBir müşteri e-postasını aramak için:\r\n<code>/usage [E-posta]</code>\r\n\r\nGelenleri aramak için (müşteri istatistikleri ile):\r\n<code>/inbound [Açıklama]</code>\r\n\r\nTelegram Sohbet Kimliği:\r\n<code>/id</code>",
      "helpClientCommands": "İstatistikleri aramak için şu komutu kullanın:\r\n\r\n<code>/usage [E-posta]</code>\r\n\r\nTelegram Sohbet Kimliği:\r\n<code>/id</code>",
      "restartUsage": "\r\n\r\n<code>/restart</code>",
      "restartSuccess": "✅ İşlem başarılı!",
      "restartFailed": "❗ İşlem hatası.\r\n\r\n<code>Hata: {{ .Error }}</code>.",
      "xrayNotRunning": "❗ Xray Core çalışmıyor.",
      "startDesc": "Ana menüyü göster",
      "helpDesc": "Bot yardımı",
      "statusDesc": "Bot durumunu kontrol et",
      "idDesc": "Telegram ID'nizi göster"
    },
    "messages": {
      "cpuThreshold": "🔴 CPU Yükü {{ .Percent }}% eşiği {{ .Threshold }}%'yi aşıyor",
      "selectUserFailed": "❌ Kullanıcı seçiminde hata!",
      "userSaved": "✅ Telegram Kullanıcısı kaydedildi.",
      "loginSuccess": "✅ Panele başarıyla giriş yapıldı.\r\n",
      "loginFailed": "❗️Panele giriş denemesi başarısız oldu.\r\n",
      "2faFailed": "2FA Hatası",
      "report": "🕰 Planlanmış Raporlar: {{ .RunTime }}\r\n",
      "datetime": "⏰ Tarih&Zaman: {{ .DateTime }}\r\n",
      "hostname": "💻 Host: {{ .Hostname }}\r\n",
      "version": "🚀 3X-UI Sürümü: {{ .Version }}\r\n",
      "xrayVersion": "📡 Xray Sürümü: {{ .XrayVersion }}\r\n",
      "ipv6": "🌐 IPv6: {{ .IPv6 }}\r\n",
      "ipv4": "🌐 IPv4: {{ .IPv4 }}\r\n",
      "ip": "🌐 IP: {{ .IP }}\r\n",
      "ips": "🔢 IP'ler:\r\n{{ .IPs }}\r\n",
      "serverUpTime": "⏳ Çalışma Süresi: {{ .UpTime }} {{ .Unit }}\r\n",
      "serverLoad": "📈 Sistem Yükü: {{ .Load1 }}, {{ .Load2 }}, {{ .Load3 }}\r\n",
      "serverMemory": "📋 RAM: {{ .Current }}/{{ .Total }}\r\n",
      "tcpCount": "🔹 TCP: {{ .Count }}\r\n",
      "udpCount": "🔸 UDP: {{ .Count }}\r\n",
      "traffic": "🚦 Trafik: {{ .Total }} (↑{{ .Upload }},↓{{ .Download }})\r\n",
      "xrayStatus": "ℹ️ Durum: {{ .State }}\r\n",
      "username": "👤 Kullanıcı Adı: {{ .Username }}\r\n",
      "reason": "❗️ Sebep: {{ .Reason }}\r\n",
      "time": "⏰ Zaman: {{ .Time }}\r\n",
      "inbound": "📍 Gelen: {{ .Remark }}\r\n",
      "port": "🔌 Port: {{ .Port }}\r\n",
      "expire": "📅 Son Kullanma Tarihi: {{ .Time }}\r\n",
      "expireIn": "📅 Sona Erecek: {{ .Time }}\r\n",
      "active": "💡 Aktif: {{ .Enable }}\r\n",
      "enabled": "🚨 Etkin: {{ .Enable }}\r\n",
      "online": "🌐 Bağlantı durumu: {{ .Status }}\r\n",
      "lastOnline": "🔙 Son çevrimiçi: {{ .Time }}\r\n",
      "email": "📧 Email: {{ .Email }}\r\n",
      "upload": "🔼 Yükleme: ↑{{ .Upload }}\r\n",
      "download": "🔽 İndirme: ↓{{ .Download }}\r\n",
      "total": "📊 Toplam: ↑↓{{ .UpDown }} / {{ .Total }}\r\n",
      "TGUser": "👤 Telegram Kullanıcısı: {{ .TelegramID }}\r\n",
      "exhaustedMsg": "🚨 Tükenmiş {{ .Type }}:\r\n",
      "exhaustedCount": "🚨 Tükenmiş {{ .Type }} sayısı:\r\n",
      "onlinesCount": "🌐 Çevrimiçi Müşteriler: {{ .Count }}\r\n",
      "disabled": "🛑 Devre Dışı: {{ .Disabled }}\r\n",
      "depleteSoon": "🔜 Yakında Tükenecek: {{ .Deplete }}\r\n\r\n",
      "backupTime": "🗄 Yedekleme Zamanı: {{ .Time }}\r\n",
      "refreshedOn": "\r\n📋🔄 Yenilendi: {{ .Time }}\r\n\r\n",
      "yes": "✅ Evet",
      "no": "❌ Hayır",
      "received_id": "🔑📥 Kimlik güncellendi.",
      "received_password": "🔑📥 Şifre güncellendi.",
      "received_email": "📧📥 E-posta güncellendi.",
      "received_comment": "💬📥 Yorum güncellendi.",
      "id_prompt": "🔑 Varsayılan Kimlik: {{ .ClientId }}\n\nKimliğinizi girin.",
      "pass_prompt": "🔑 Varsayılan Şifre: {{ .ClientPassword }}\n\nŞifrenizi girin.",
      "email_prompt": "📧 Varsayılan E-posta: {{ .ClientEmail }}\n\nE-postanızı girin.",
      "comment_prompt": "💬 Varsayılan Yorum: {{ .ClientComment }}\n\nYorumunuzu girin.",
      "inbound_client_data_id": "🔄 Giriş: {{ .InboundRemark }}\n\n🔑 Kimlik: {{ .ClientId }}\n📧 E-posta: {{ .ClientEmail }}\n📊 Trafik: {{ .ClientTraffic }}\n📅 Bitiş Tarihi: {{ .ClientExp }}\n🌐 IP Sınırı: {{ .IpLimit }}\n💬 Yorum: {{ .ClientComment }}\n\nArtık bu müşteriyi girişe ekleyebilirsin!",
      "inbound_client_data_pass": "🔄 Giriş: {{ .InboundRemark }}\n\n🔑 Şifre: {{ .ClientPass }}\n📧 E-posta: {{ .ClientEmail }}\n📊 Trafik: {{ .ClientTraffic }}\n📅 Bitiş Tarihi: {{ .ClientExp }}\n🌐 IP Sınırı: {{ .IpLimit }}\n💬 Yorum: {{ .ClientComment }}\n\nArtık bu müşteriyi girişe ekleyebilirsin!",
      "cancel": "❌ İşlem iptal edildi! \n\nİstediğiniz zaman /start ile yeniden başlayabilirsiniz. 🔄",
      "error_add_client": "⚠️ Hata:\n\n {{ .error }}",
      "using_default_value": "Tamam, varsayılan değeri kullanacağım. 😊",
      "incorrect_input": "Girdiğiniz değer geçerli değil.\nKelime öbekleri boşluk olmadan devam etmelidir.\nDoğru örnek: aaaaaa\nYanlış örnek: aaa aaa 🚫",
      "AreYouSure": "Emin misin? 🤔",
      "SuccessResetTraffic": "📧 E-posta: {{ .ClientEmail }}\n🏁 Sonuç: ✅ Başarılı",
      "FailedResetTraffic": "📧 E-posta: {{ .ClientEmail }}\n🏁 Sonuç: ❌ Başarısız \n\n🛠️ Hata: [ {{ .ErrorMessage }} ]",
      "FinishProcess": "🔚 Tüm müşteriler için trafik sıfırlama işlemi tamamlandı."
    },
    "buttons": {
      "closeKeyboard": "❌ Klavyeyi Kapat",
      "cancel": "❌ İptal",
      "cancelReset": "❌ Sıfırlamayı İptal Et",
      "cancelIpLimit": "❌ IP Limitini İptal Et",
      "confirmResetTraffic": "✅ Trafiği Sıfırlamayı Onayla?",
      "confirmClearIps": "✅ IP'leri Temizlemeyi Onayla?",
      "confirmRemoveTGUser": "✅ Telegram Kullanıcısını Kaldırmayı Onayla?",
      "confirmToggle": "✅ Kullanıcıyı Etkinleştirme/Devre Dışı Bırakmayı Onayla?",
      "dbBackup": "Veritabanı Yedeği Al",
      "serverUsage": "Sunucu Kullanımı",
      "getInbounds": "Gelenleri Al",
      "depleteSoon": "Yakında Tükenecek",
      "clientUsage": "Kullanımı Al",
      "onlines": "Çevrimiçi Müşteriler",
      "commands": "Komutlar",
      "refresh": "🔄 Yenile",
      "clearIPs": "❌ IP'leri Temizle",
      "removeTGUser": "❌ Telegram Kullanıcısını Kaldır",
      "selectTGUser": "👤 Telegram Kullanıcısını Seç",
      "selectOneTGUser": "👤 Bir Telegram Kullanıcısını Seçin:",
      "resetTraffic": "📈 Trafiği Sıfırla",
      "resetExpire": "📅 Son Kullanma Tarihini Değiştir",
      "ipLog": "🔢 IP Günlüğü",
      "ipLimit": "🔢 IP Limiti",
      "setTGUser": "👤 Telegram Kullanıcısını Ayarla",
      "toggle": "🔘 Etkinleştir / Devre Dışı Bırak",
      "custom": "🔢 Özel",
      "confirmNumber": "✅ Onayla: {{ .Num }}",
      "confirmNumberAdd": "✅ Ekleme onayı: {{ .Num }}",
      "limitTraffic": "🚧 Trafik Sınırı",
      "getBanLogs": "Yasak Günlüklerini Al",
      "allClients": "Tüm Müşteriler",
      "addClient": "Müşteri Ekle",
      "submitDisable": "Devre Dışı Olarak Gönder ☑️",
      "submitEnable": "Etkin Olarak Gönder ✅",
      "use_default": "🏷️ Varsayılanı Kullan",
      "change_id": "⚙️🔑 ID",
      "change_password": "⚙️🔑 Şifre",
      "change_email": "⚙️📧 Email",
      "change_comment": "⚙️💬 Yorum",
      "change_flow": "⚙️🚦 Flow",
      "ResetAllTraffics": "Tüm Trafikleri Sıfırla",
      "SortedTrafficUsageReport": "Sıralı Trafik Kullanım Raporu"
    },
    "answers": {
      "successfulOperation": "✅ İşlem başarılı!",
      "errorOperation": "❗ İşlemde hata.",
      "getInboundsFailed": "❌ Gelenler alınamadı.",
      "getClientsFailed": "❌ Müşteriler alınamadı.",
      "canceled": "❌ {{ .Email }}: İşlem iptal edildi.",
      "clientRefreshSuccess": "✅ {{ .Email }}: Müşteri başarıyla yenilendi.",
      "IpRefreshSuccess": "✅ {{ .Email }}: IP'ler başarıyla yenilendi.",
      "TGIdRefreshSuccess": "✅ {{ .Email }}: Müşterinin Telegram Kullanıcısı başarıyla yenilendi.",
      "resetTrafficSuccess": "✅ {{ .Email }}: Trafik başarıyla sıfırlandı.",
      "setTrafficLimitSuccess": "✅ {{ .Email }}: Trafik limiti başarıyla kaydedildi.",
      "expireResetSuccess": "✅ {{ .Email }}: Son kullanma günleri başarıyla sıfırlandı.",
      "resetIpSuccess": "✅ {{ .Email }}: IP limiti {{ .Count }} başarıyla kaydedildi.",
      "clearIpSuccess": "✅ {{ .Email }}: IP'ler başarıyla temizlendi.",
      "getIpLog": "✅ {{ .Email }}: IP Günlüğü alındı.",
      "getUserInfo": "✅ {{ .Email }}: Telegram Kullanıcı Bilgisi alındı.",
      "removedTGUserSuccess": "✅ {{ .Email }}: Telegram Kullanıcısı başarıyla kaldırıldı.",
      "enableSuccess": "✅ {{ .Email }}: Başarıyla etkinleştirildi.",
      "disableSuccess": "✅ {{ .Email }}: Başarıyla devre dışı bırakıldı.",
      "askToAddUserId": "Yapılandırmanız bulunamadı!\r\nLütfen yöneticinizden yapılandırmalarınıza Telegram ChatID'nizi eklemesini isteyin.\r\n\r\nKullanıcı ChatID'niz: <code>{{ .TgUserID }}</code>",
      "chooseClient": "Gelen {{ .Inbound }} için bir Müşteri Seçin",
      "chooseInbound": "Bir Gelen Seçin"
    }
  }
}
